/** 是或否的枚举 */
export enum YesOrNo {
  /** 是 */
  Yes = '1',
  /** 否 */
  No = '2',
}

/** 是或否的文本映射 */
export const yesOrNoMap = {
  [YesOrNo.Yes]: $t('是'),
  [YesOrNo.No]: $t('否'),
};

/** 状态码枚举值 */
export enum RetCode {
  /** 框架层用户未登录 */
  NotLogin = 100000,
  /** 用户未注册 */
  UserNotRegister = 252810001,
  /** 用户已注册待审核 */
  UserNotAudit = 252810002,
  /** 供应商短链失效 */
  SupplierLinkCodeError = 252810007,
  /** 验证码错误 */
  PhoneCodeError = 100010,
  /** 验证码已发送 */
  PhoneCodeSended = 25301003,
  /** 测试环境非白名单手机号 */
  TestEnvNotWhitePhone = 100006,
}

/** 腾讯云验证码APPID */
export const TaptchaAppId = '2000809457';
